import React from "react";
import ReactDOM from "react-dom/client";
import "index.css";
import App from "App";
import { StyleProvider } from "@ant-design/cssinjs";
import { BrowserRouter } from "react-router-dom";
import { persistor, store } from "store";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { ConfigProvider } from "antd";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <BrowserRouter>
          <StyleProvider layer>
            <ConfigProvider
              theme={{
                components: {
                  Button: {
                    borderRadius: 9999,
                    fontWeight: 600,
                  },
                },
              }}
            >
              <App />
            </ConfigProvider>
          </StyleProvider>
        </BrowserRouter>
      </PersistGate>
    </Provider>
  </React.StrictMode>,
);
